import { createIcon } from '../createIcon.tsx';

export const PauseIcon = createIcon(
	'PauseIcon',
	<>
		<rect x="6" y="4" width="4" height="16" />
		<rect x="14" y="4" width="4" height="16" />
	</>,
);
